/**
 * Resolve once the browser has painted the server-rendered HTML (M6).
 *
 * `requestAnimationFrame` runs right BEFORE a frame is painted; the macrotask
 * queued from inside it runs right AFTER that paint. A hidden tab never paints
 * (rAF is paused there), so it resolves immediately instead of waiting for
 * the tab to become visible.
 */
export function afterFirstPaint(): Promise<void> {
  return new Promise((resolve) => {
    if (document.visibilityState === 'hidden') {
      resolve()
      return
    }
    requestAnimationFrame(() => {
      const channel = new MessageChannel()
      channel.port1.onmessage = () => resolve()
      channel.port2.postMessage(undefined)
    })
  })
}
